import script from "./cardMoudle4.vue?vue&type=script&setup=true&lang=js"
export * from "./cardMoudle4.vue?vue&type=script&setup=true&lang=js"

import "./cardMoudle4.vue?vue&type=style&index=0&id=40c71607&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40c71607"]])

export default __exports__